import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FaEdit, FaImage } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";

import { ThemeContext } from "../../context/ThemeContext";
import { Table, Pagination, Input } from "rsuite";
import getBase64 from "../../helper/helper";

import { useGetAllFishInfoQuery } from "../../features/fish/fishApi";
import { useCreateFishMutation } from "../../features/fish/fishApi";
import { useUpdateFishMutation } from "../../features/fish/fishApi";

import { useGetFishTankListQuery } from "../../features/fish/fishAssignApi";
import { useGetAllTanksListQuery } from "../../features/tank/tankApi";
import { useFishTankAssignMutation } from "../../features/fish/fishAssignApi";
import { useFishTankUnAssignMutation } from "../../features/fish/fishAssignApi";

import { useGetDailyFishFeedListQuery } from "../../features/fish/fishDailyFeedApi";
import { useCreateDailyFishFeedMutation } from "../../features/fish/fishDailyFeedApi";
import { useUpdateDailyFishFeedMutation } from "../../features/fish/fishDailyFeedApi";
import { useGetFishFeedListQuery } from "../../features/fish/fishFeedApi";

// import "./styles/premises.css";
const { Column, HeaderCell, Cell } = Table;

function FishDailyFeed() {
  const theme = React.useContext(ThemeContext);
  const [show, setShow] = React.useState(false);
  const [createFormSelector, setCreateFormSelector] = useState(true);
  const [reseponseMessage, setResponseMessage] = useState();
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);
  const [updateFormData, setUpdateFormData] = useState({});
  const [tableLoading, setTableLoading] = useState(true);

  const [fishList, setFishList] = useState([]);
  const [tankList, setTankList] = useState([]);
  const [feedList, setFeedList] = useState([]);

  const { data: dailyFishFeedList, isLoading } = useGetDailyFishFeedListQuery();

  const { data: allFeedList, isLoading: feedListLoading } =
    useGetFishFeedListQuery();

  const { data: allFishList, isLoading: fishListLoading } =
    useGetAllFishInfoQuery();
  const { data: allTankList, isLoading: tankListLoading } =
    useGetAllTanksListQuery();

  const [createDailyFishFeed] = useCreateDailyFishFeedMutation();

  const [updateDailyFishFeed] = useUpdateDailyFishFeedMutation();

  let defaultData = [];
  let data = [];

  useEffect(() => {
    if (!isLoading) {
      setTableLoading(false);
    }
  }, [isLoading]);

  useEffect(() => {
    if (!fishListLoading) {
      setFishList(allFishList?.data);
    }
    if (!tankListLoading) {
      setTankList(allTankList?.data);
    }
    if (!feedListLoading) {
      setFeedList(allFeedList?.data);
    }
  }, [fishListLoading, tankListLoading, feedListLoading]);

  if (!isLoading) {
    if (dailyFishFeedList.success) {
      defaultData = [...dailyFishFeedList?.data];
      defaultData = defaultData?.map((fishTankInfo) => {
        const data = new Date(fishTankInfo.updated_at);
        const formattedDate = data.toLocaleString();
        return {
          ...fishTankInfo,
          updated_at: formattedDate,
        };
      });
    }

    data = defaultData?.filter((v, i) => {
      const start = limit * (page - 1);
      const end = start + limit;
      return i >= start && i < end;
    });
  }

  const handleClose = () => {
    setShow(false);
  };
  const handleModalOutsideClick = () => {
    setShow(false);
    setResponseMessage("");
  };
  const handleChangeLimit = (dataKey) => {
    setPage(1);
    setLimit(dataKey);
  };
  const formSubmitHandler = (e) => {
    e.preventDefault();

    if (createFormSelector) {
      createDailyFishFeed(updateFormData)
        .unwrap()
        .then((payload) => setResponseMessage(payload?.message))
        .catch((error) => setResponseMessage(error?.status));
    } else {
      updateDailyFishFeed(updateFormData)
        .unwrap()
        .then((payload) => setResponseMessage(payload?.message))
        .catch((error) => setResponseMessage(error?.status));
    }
  };
  const handleEdit = (id) => {
    // alert(id);
    let formData = defaultData.find((object) => object.id == id) || {};
    setUpdateFormData(formData);
    // console.log(formData);
  };
  const dataChangeHandler = (e) => {
    setResponseMessage(""); //to hide form submit message on change
    if (e.target.name == "feed_date_time") {
      const date = e.target.value;
      // const formattedDateTime = date.toLocaleString();
      const formattedDateTime = date
        .replace("T", " ")
        // .replace("-", "-")
        // .replace(":", ":")
        .substring(0, 19);

      setUpdateFormData((previousValue) => ({
        ...previousValue,
        [e.target.name]: formattedDateTime,
        // [e.target.name]: e.target.value,
      }));
    } else {
      setUpdateFormData((previousValue) => ({
        ...previousValue,
        [e.target.name]: e.target.value,
      }));
    }
  };

  return (
    <div className={`row row-sm ${theme} `}>
      <div style={{ textAlign: "right", marginBottom: "1rem" }}>
        <button
          className="btn btn-primary btn-md "
          // style={{ width: "20vw" }}
          onClick={() => {
            setShow(true);
            setCreateFormSelector(true);
            setUpdateFormData({});
          }}
        >
          Create Daily Feed
        </button>
        {/* </div> */}
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        classname={`${theme} `}
        centered
        onExited={handleModalOutsideClick}
      >
        <div className={`${theme}`}>
          <Modal.Header
            className="theme-background theme-text"
            style={{ borderRadius: "0px" }}
          >
            <Modal.Title>
              {createFormSelector ? "Create Daily Feed" : "Update Daily Feed"}
            </Modal.Title>
            <div style={{ color: "green" }}>{reseponseMessage}</div>
            <RxCross2 onClick={handleModalOutsideClick} />
          </Modal.Header>
          <Modal.Body className="theme-background theme-text">
            {" "}
            <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12 zero-padding">
              <div>
                <div>
                  <form onSubmit={formSubmitHandler}>
                    <div className="form-group">
                      <label>
                        Feed Time <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="datetime-local"
                        className="form-control"
                        name="feed_date_time"
                        defaultValue={updateFormData?.feed_date_time || ""}
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                        required
                      />
                    </div>
                    <div class="form-group">
                      <label class="form-label">
                        Select Tank <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        required
                        name="tank_id"
                        class="form-control form-select"
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                        defaultValue={updateFormData?.tank_id || ""}
                      >
                        <option label="Choose one"></option>
                        {tankList?.map((tankInfo) => {
                          return (
                            <option value={tankInfo?.id}>
                              {tankInfo?.tank_name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div class="form-group">
                      <label class="form-label">
                        Select Feed <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        required
                        name="feed_id"
                        class="form-control form-select"
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                        defaultValue={updateFormData?.feed_id || ""}
                      >
                        <option label="Choose one"></option>
                        {feedList?.map((feedInfo) => {
                          return (
                            <option value={feedInfo?.id}>
                              {feedInfo?.feed_name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    {/* <div className="form-group">
                      <label>
                        Feed Buoyancy <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Feed Buoyancy"
                        name="feed_buoyancy"
                        defaultValue={updateFormData?.feed_buoyancy || ""}
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                      />
                    </div> */}
                    <div class="form-group">
                      <label class="form-label">
                        Select Feed Buoyancy{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        required
                        name="feed_buoyancy"
                        class="form-control form-select"
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                        defaultValue={updateFormData?.feed_buoyancy || ""}
                      >
                        <option label="Choose one"></option>
                        <option value="Sinking">Sinking</option>
                        <option value="Floating">Floating</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>
                        Feed Quantity <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        required
                        type="text"
                        className="form-control"
                        placeholder="Feed Quantity"
                        name="feed_quantity"
                        defaultValue={updateFormData?.feed_quantity || ""}
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                      />
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <Button type="submit">Submit</Button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </Modal.Body>
        </div>
      </Modal>
      <div>
        <div className="table-responsive theme-background theme-text">
          <Table height={500} data={data || []} loading={tableLoading}>
            <Column
              width={50}
              align="center"
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Id.</HeaderCell>
              <Cell dataKey="id" />
            </Column>
            <Column
              width={100}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Feed Name</HeaderCell>
              <Cell dataKey="feed_name" />
            </Column>
            <Column
              width={100}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Tank Name</HeaderCell>
              <Cell dataKey="tank_name" />
            </Column>
            <Column
              width={100}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>
                Feed Quantity
              </HeaderCell>
              <Cell dataKey="feed_quantity" />
            </Column>
            <Column
              width={100}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Feed Grade</HeaderCell>
              <Cell dataKey="feed_grade" />
            </Column>
            <Column
              width={100}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>
                Feed Buoyancy
              </HeaderCell>
              <Cell dataKey="feed_buoyancy" />
            </Column>
            <Column
              width={100}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Feed Time</HeaderCell>
              <Cell dataKey="feed_date_time" />
            </Column>
            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Last Updated</HeaderCell>
              <Cell dataKey="updated_at" />
            </Column>
            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Edit</HeaderCell>
              <Cell>
                {(rowData) => (
                  <div
                    icon="edit"
                    onClick={() => {
                      setShow(true);
                      setCreateFormSelector(false);
                      handleEdit(rowData.id);
                    }}
                  >
                    <FaEdit />
                  </div>
                )}
              </Cell>
            </Column>
          </Table>
          <div style={{ padding: 20 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="lg"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              total={defaultData.length}
              limitOptions={[10, 30, 50]}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default FishDailyFeed;
